import { pageNames } from '@atc/bonnet-paths';
import activeDuckCreator from './creators/activeDuckCreator';

export default activeDuckCreator({
    namespace: pageNames.DEALER_DETAILS,
    store: 'activeOwner',
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
